import { render, staticRenderFns } from "./BarChartApex.vue?vue&type=template&id=07f74699&scoped=true&"
import script from "./BarChartApex.vue?vue&type=script&lang=js&"
export * from "./BarChartApex.vue?vue&type=script&lang=js&"
import style0 from "./BarChartApex.vue?vue&type=style&index=0&id=07f74699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f74699",
  null
  
)

export default component.exports